import { render, staticRenderFns } from "./SceneSms.vue?vue&type=template&id=64161aec&scoped=true&"
import script from "./SceneSms.vue?vue&type=script&lang=js&"
export * from "./SceneSms.vue?vue&type=script&lang=js&"
import style0 from "./SceneSms.vue?vue&type=style&index=0&id=64161aec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64161aec",
  null
  
)

export default component.exports